module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('h3', [_vm._v("Send til nytt verksted:")]), _vm._v(" "), _c('div', {
    staticClass: "inputWrap"
  }, [_c('v-select', {
    attrs: {
      "placeholder": "Verksted",
      "label": "select_value",
      "options": _vm.workshops
    },
    model: {
      value: (_vm.workshop),
      callback: function($$v) {
        _vm.workshop = $$v
      },
      expression: "workshop"
    }
  }), _vm._v(" "), (_vm.localErrors.workshop) ? _c('span', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.localErrors.workshop)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.close()
      }
    }
  }, [_vm._v("Avbryt")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteRequest()
      }
    }
  }, [_vm._v("Kanseller")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeWorkshop()
      }
    }
  }, [_vm._v("Send")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("delete")]), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("published_with_changes")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4183d6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./requests/assets/src/components/Opq/tags/DeleteDialog.vue
// module id = 122
// module chunks = 0